import $ from "cash-dom";
import anime from "animejs";

export const examplesComponent = async () => {
  const scroll = $("#examples-desktop-scroll").get(0);
  const $back = $("#examples-desktop-back");
  const $forward = $("#examples-desktop-forward");

  if (!scroll) return;

  const parsedItemsPerScroll = parseInt(
    scroll.getAttribute("data-items-per-scroll"),
  );
  const itemsPerScroll = Number.isNaN(parsedItemsPerScroll)
    ? 1
    : Math.max(1, parsedItemsPerScroll);

  let activeIndex = 0;
  let maxIndex = 0;

  const visibleCards = () =>
    Array.from(scroll.children).filter(
      (card) => window.getComputedStyle(card).display !== "none",
    );

  const setButtonState = ($button, enabled) => {
    const button = $button.get(0);

    if (enabled) {
      $button
        .removeClass(
          "bg-transparent border-gray text-gray hover:border-gray-dark hover:text-gray-dark",
        )
        .addClass(
          "bg-white border-red text-red hover:border-red-dark hover:text-red-dark",
        );
    } else {
      $button
        .removeClass(
          "bg-white border-red text-red hover:border-red-dark hover:text-red-dark",
        )
        .addClass(
          "bg-transparent border-gray text-gray hover:border-gray-dark hover:text-gray-dark",
        );
    }

    if (button) {
      button.disabled = !enabled;
      button.setAttribute("aria-disabled", String(!enabled));
    }
  };

  const update = (animate = true) => {
    const cards = visibleCards();
    const cardWidth =
      cards[0]?.getBoundingClientRect().width || scroll.offsetWidth;
    const viewportWidth =
      scroll.parentElement?.clientWidth || scroll.offsetWidth;
    const itemsInView = Math.max(1, Math.round(viewportWidth / cardWidth));
    const lastCardIndex = Math.max(0, cards.length - itemsInView);

    maxIndex = Math.ceil(lastCardIndex / itemsPerScroll);
    activeIndex = Math.min(activeIndex, maxIndex);

    setButtonState($back, activeIndex > 0);
    setButtonState($forward, activeIndex < maxIndex);

    const maxOffset = Math.max(0, scroll.scrollWidth - viewportWidth);
    const offset = Math.min(
      activeIndex * itemsPerScroll * cardWidth,
      maxOffset,
    );

    anime.remove(scroll);
    anime({
      targets: scroll,
      left: -offset,
      duration: animate ? 250 : 0,
      easing: "easeOutQuad",
    });
  };

  const initialId = scroll.getAttribute("data-initial-id");
  if (initialId) {
    const initialCard = document.getElementById(`example-${initialId}`);
    const initialCardIndex = visibleCards().indexOf(initialCard);

    if (initialCardIndex >= 0) {
      activeIndex = Math.floor(initialCardIndex / itemsPerScroll);
    }
  }

  $back.on("click", () => {
    if (activeIndex > 0) {
      --activeIndex;
      update();
    }
  });
  $forward.on("click", () => {
    if (activeIndex < maxIndex) {
      ++activeIndex;
      update();
    }
  });

  window.addEventListener("resize", () => update(false));

  update(false);
  setupExampleFilters(() => {
    activeIndex = 0;
    update();
  });
};

// CATEGORY FILTERING
const setupExampleFilters = (onFilterChange) => {
  const filterButtons = document.querySelectorAll(".example-filter-button");
  const cards = document.querySelectorAll(
    "#examples-desktop-scroll [data-category]",
  );

  // Get all unique valid categories from cards
  const validCategories = new Set();
  cards.forEach((card) => {
    const cat = card.getAttribute("data-category");
    if (cat) cat.split(" ").forEach((slug) => validCategories.add(slug));
  });

  filterButtons.forEach((btn) => {
    btn.addEventListener("click", () => {
      const selectedCategory = btn.getAttribute("data-category");

      // Update button styles (flip colors)
      filterButtons.forEach((b) => {
        b.removeAttribute("active");
        b.classList.remove("bg-black", "text-white");
        b.classList.add("bg-transparent", "text-black");
      });
      btn.classList.remove("bg-transparent", "text-black");
      btn.classList.add("bg-black", "text-white");

      btn.setAttribute("active", "");
      btn.classList.add("bg-black", "text-white");
      btn.classList.remove("bg-transparent", "text-black");

      // Handle fallback
      const isValid =
        selectedCategory === "vsetky" || validCategories.has(selectedCategory);
      if (!isValid) {
        console.warn(`Invalid category slug: ${selectedCategory}`);
      }

      cards.forEach((card) => {
        const cardCategory = card.getAttribute("data-category") || "";
        const show =
          selectedCategory === "vsetky" ||
          cardCategory.split(" ").includes(selectedCategory);
        card.style.display = isValid && show ? "" : "none";
      });

      onFilterChange();
    });
  });
};
